import styled from 'styled-components';

export const HeadingAndActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionsContainer = styled.div``;
